let UTILS = require("../libs/utils.js");
var v7762;
var v7763;
module.exports = {
  id: "krank",
  name: "Kranked FFA",
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  endStats: ["sid", "name", "score", "kills", "deaths", "reward"],
  leaderStats: ["score", "kills", "deaths"],
  alias: "krank",
  forceSpawn: 5,
  krankedTimer: 15000,
  bonuses: {
    speed: 1.25,
    reload: 0.35,
    firerate: 0.85
  },
  update: function (game, p9251, p9252) {
    for (var vLN01245 = 0; vLN01245 < game.players.list.length; ++vLN01245) {
      if (game.players.list[vLN01245].active && game.players.list[vLN01245].krankedTimer) {
        game.players.list[vLN01245].krankedTimer -= p9252;
        if (game.players.list[vLN01245].krankedTimer <= 0) {
          game.explosion(game.players.list[vLN01245].x, game.players.list[vLN01245].y + 6, game.players.list[vLN01245].z, 50, 300, game.players.list[vLN01245], {});
          game.players.kill(game.players.list[vLN01245]);
        }
      }
    }
  },
  onKill: function (game, p9254, p9255, p9256) {
    if (p9256 && p9256 != p9255) {
      var v7764 = p9256.isKranked;
      p9256.krankedTimer = game.mode.krankedTimer;
      p9256.isKranked = true;
      game.broadcast("chrg", p9256.sid, p9256.krankedTimer);
      if (v7764 || p9255.isKranked) {
        game.players.score(p9256, 35);
        game.incMedal(v7764 ? "Recharge" : "Clock Work", p9256);
        p9256.send("am", [v7764 ? 28 : 27, 35, 0, 1]);
        if (v7764) {
          game.challenges.update(game, "rcm", 1, null, p9256);
        }
      }
    }
  }
};